import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "General enquiry", message: "" });
  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message, {
        duration: 10000,
        action: data.whatsapp_url ? { label: "Also send on WhatsApp", onClick: () => window.open(data.whatsapp_url, "_blank") } : undefined,
      });
      setForm({ name: "", email: "", phone: "", subject: "General enquiry", message: "" });
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || err.message); }
  };
  return (
    <div className="pt-32 pb-24 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12">
        <div>
          <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] font-semibold">Contact</div>
          <h1 className="mt-3 text-5xl font-bold text-blue-950 dark:text-white">Let's plan your escape.</h1>
          <p className="mt-4 text-slate-600 dark:text-slate-300">Tell us where you're dreaming of — our concierge team responds within a few hours.</p>
          <div className="mt-8 space-y-4 text-slate-700 dark:text-slate-200">
            <div className="flex items-center gap-3"><Phone className="w-5 h-5 text-[#D4AF37]"/><a href="tel:+919891782652">+91 9891782652</a></div>
            <div className="flex items-center gap-3"><Mail className="w-5 h-5 text-[#D4AF37]"/><a href="mailto:Himanshu@yourtrips.co.in">Himanshu@yourtrips.co.in</a></div>
            <div className="flex items-center gap-3"><MapPin className="w-5 h-5 text-[#D4AF37]"/>New Delhi, Delhi, India</div>
          </div>
          <div className="mt-6 flex gap-3">
            <a href="https://instagram.com/yourtrips" target="_blank" rel="noreferrer" className="w-11 h-11 rounded-full glass flex items-center justify-center hover:text-[#D4AF37]"><Instagram className="w-4 h-4"/></a>
            <a href="https://www.facebook.com/share/19Js5xWC6R/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="w-11 h-11 rounded-full glass flex items-center justify-center hover:text-[#D4AF37]"><Facebook className="w-4 h-4"/></a>
          </div>
          <div className="mt-8 rounded-3xl overflow-hidden shadow-xl">
            <iframe title="map" width="100%" height="280" style={{border:0}} loading="lazy"
              src="https://maps.google.com/maps?q=New%20Delhi%2C%20India&t=&z=11&ie=UTF8&iwloc=&output=embed"/>
          </div>
        </div>
        <form onSubmit={submit} data-testid="contact-form" className="rounded-3xl p-8 bg-white dark:bg-slate-900 border border-slate-200/70 dark:border-white/10 space-y-4 h-fit">
          <div className="grid md:grid-cols-2 gap-4">
            <Input label="Name" required value={form.name} onChange={change("name")} data-testid="contact-name"/>
            <Input label="Email" type="email" required value={form.email} onChange={change("email")} data-testid="contact-email"/>
            <Input label="Phone" value={form.phone} onChange={change("phone")} data-testid="contact-phone"/>
            <Input label="Subject" value={form.subject} onChange={change("subject")} data-testid="contact-subject"/>
          </div>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-slate-500">Message</span>
            <textarea data-testid="contact-message" required rows={5} value={form.message} onChange={change("message")}
              className="mt-1 w-full rounded-2xl border border-slate-200 dark:border-white/10 bg-transparent px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"/>
          </label>
          <button data-testid="contact-submit" className="w-full py-4 rounded-full btn-gold text-sm">Send Message</button>
        </form>
      </div>
    </div>
  );
}
function Input({ label, ...rest }) {
  return (
    <label className="block">
      <span className="text-xs uppercase tracking-widest text-slate-500">{label}</span>
      <input {...rest} className="mt-1 w-full rounded-2xl border border-slate-200 dark:border-white/10 bg-transparent px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"/>
    </label>
  );
}
